<div class="auth-card">
  <!-- Logo -->
  <div class="auth-logo">
    <img src="assets/images/horseloop-logo.png" alt="HorseLoop" />
  </div>

  @if (verificationStatus === 'verifying') {
    <!-- Verifying State -->
    <div class="auth-header">
      <h1>{{ 'auth.verifyEmail.verifying.title' | translate }}</h1>
      <p>{{ 'auth.verifyEmail.verifying.subtitle' | translate }}</p>
    </div>

    <div class="alert alert-info">
      <i class="fa fa-spinner spinner"></i>
      <div>
        <strong>{{ 'auth.verifyEmail.verifying.message' | translate }}</strong>
        <p class="mb-0">{{ 'auth.verifyEmail.verifying.description' | translate }}</p>
      </div>
    </div>
  }

  @if (verificationStatus === 'success') {
    <!-- Success State -->
    <div class="auth-header">
      <h1>{{ 'auth.verifyEmail.success.title' | translate }}</h1>
      <p>{{ 'auth.verifyEmail.success.subtitle' | translate }}</p>
    </div>

    <div class="alert alert-success">
      <i class="fa fa-check-circle"></i>
      <div>
        <strong>{{ 'auth.verifyEmail.success.message' | translate }}</strong>
        <p class="mb-0">{{ 'auth.verifyEmail.success.description' | translate }}</p>
      </div>
    </div>

    <button
      type="button"
      class="btn btn-primary"
      routerLink="/dashboard"
    >
      {{ 'auth.verifyEmail.success.goToDashboard' | translate }}
    </button>
  }

  @if (verificationStatus === 'error') {
    <!-- Error State -->
    <div class="auth-header">
      <h1>{{ 'auth.verifyEmail.error.title' | translate }}</h1>
      <p>{{ 'auth.verifyEmail.error.subtitle' | translate }}</p>
    </div>

    <div class="alert alert-error">
      <i class="fa fa-exclamation-circle"></i>
      <div>
        <strong>{{ 'auth.verifyEmail.error.message' | translate }}</strong>
        <p class="mb-0">{{ errorMessage || ('auth.verifyEmail.error.description' | translate) }}</p>
      </div>
    </div>

    <!-- Divider -->
    <div class="auth-divider">
      <span>{{ 'auth.verifyEmail.error.needHelp' | translate }}</span>
    </div>

    <!-- Actions -->
    <button
      type="button"
      class="btn btn-outline"
      routerLink="/auth/login"
    >
      <i class="fa fa-arrow-left me-2"></i>
      {{ 'auth.common.backToLogin' | translate }}
    </button>
  }
</div>
